var _mask, _mask2, _circle, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCircleLimeDeadline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "icon-circle-lime--deadline_svg__a",
    height: 37,
    maskUnits: "userSpaceOnUse",
    width: 37,
    x: 6,
    y: 7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 7h37v37H6z",
    fill: "#d9d9d9"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "icon-circle-lime--deadline_svg__b",
    height: 40,
    maskUnits: "userSpaceOnUse",
    width: 41,
    x: 5,
    y: 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.031 5h40v40h-40z",
    fill: "#d9d9d9"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    fill: "#e3fb94",
    r: 25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-circle-lime--deadline_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#231f20",
    mask: "url(#icon-circle-lime--deadline_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6 24.299h2.66c.42 0 .7.35.7.7 0 .42-.35.7-.7.7H14.6c-.42 0-.7-.35-.7-.7 0-.42.35-.7.7-.7zM24.331 14.57v2.66c0 .42.35.7.7.7.42 0 .7-.35.7-.7v-2.66c0-.42-.35-.7-.7-.7-.42 0-.7.35-.7.7zM25.731 35.43v-2.66c0-.42-.35-.7-.7-.7-.42 0-.7.28-.7.7v2.66c0 .421.35.701.7.701.42 0 .7-.35.7-.7zM32.803 24.299h2.66c.42 0 .7.35.7.7 0 .42-.35.7-.7.7h-2.66c-.42 0-.7-.35-.7-.7 0-.42.28-.7.7-.7zM30.002 19.959l-4.55 4.55c-.21-.07-.49-.07-.7 0l-6.232-6.23a.677.677 0 00-.98 0c-.28.28-.28.7 0 .98l6.231 6.23c-.14.49 0 1.05.42 1.4.14.141.42.281.63.351.91.21 1.75-.49 1.75-1.4 0-.14 0-.21-.07-.35l4.552-4.551c.56-.7-.42-1.61-1.05-.98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.801 10.017C16.91 9.597 9.628 16.88 10.05 25.77c.42 7.631 6.58 13.793 14.212 14.213 8.892.42 16.173-6.861 15.753-15.753-.42-7.631-6.581-13.793-14.213-14.213zm.42 27.865c-8.051.7-14.772-6.02-14.072-14.072.56-6.161 5.53-11.132 11.692-11.692 8.052-.7 14.773 6.02 14.073 14.072-.56 6.161-5.531 11.132-11.692 11.692z"
  })))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle-lime--deadline-a27b27dab86744f02312d2b3500ed109.svg";
export { SvgIconCircleLimeDeadline as Component };